import React, { useContext } from 'react';

import { Anchor, TextButton } from '@zillow/constellation-10';
import { IconExternalOutline } from '@zillow/constellation-icons';

import { ModularListingContext } from '../../../../../containers/CreateListingPage/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../../constants/WizardConstants';

import LCPetPolicyFormFieldContainer from '../LCPetPolicyFormFieldContainer';
import WizardAlert from '../../../../WizardAlert';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../../styles/wizard';

const animalExemptionURL = 'https://www.hud.gov/program_offices/fair_housing_equal_opp/assistance_animals';

const propTypes = {};
const defaultProps = {};

const LCPetPolicyFormSectionContainer = () => {
  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  return (
    <WizardFormSectionContainer data-testid="LCPetPolicyFormSectionContainer">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />

      <WizardHeading level={1} textStyle="heading-sm">
        What&apos;s your pet policy?
      </WizardHeading>

      <WizardBody>
        <TextButton asChild icon={<IconExternalOutline />} iconPosition="end" textStyle="body">
          <Anchor target="_blank" href={animalExemptionURL}>
            Review the Assistance Animal Exemption
          </Anchor>
        </TextButton>
      </WizardBody>

      <LCPetPolicyFormFieldContainer />
    </WizardFormSectionContainer>
  );
};

LCPetPolicyFormSectionContainer.propTypes = propTypes;
LCPetPolicyFormSectionContainer.defaultProps = defaultProps;

export default LCPetPolicyFormSectionContainer;
